<template>
    <div class="add-section-container" :class="styles.COLUMNS.COL12" @click="showOption">
        <p>
            <span v-html="$form.getIcon('addOutline', '32px', '32px', '#000')"></span>
            <span>Add Section</span>
        </p>

        <div :class="[styles.LIST_GROUP.CONTAINER, 'add-container-list']" v-show="show">

            <a href="javascript:void(0)"
               :class="styles.LIST_GROUP.SINGLE_ITEM"
               v-for="(sectionInfo, sectionKey) in sectionTypes"
               :key="sectionKey"
               @click="addNew(sectionKey)">

                <p class="type-headline" v-text="sectionInfo.name"></p>
                <p class="type-desc" v-text="sectionInfo.description"></p>

            </a>

            <!-- one section of another form on this site -> SectionCopyModal (GlobalModal) -->
            <a href="javascript:void(0)"
               :class="styles.LIST_GROUP.SINGLE_ITEM"
               data-test="add-section-copy"
               @click="openCopyModal">

                <p class="type-headline">Copy a section from another form&hellip;</p>
                <p class="type-desc">Pick a form on this site and bring one of its sections here</p>

            </a>

        </div>
    </div>
</template>

<script>
    import {STYLES} from "../../../configs/styles";
    import {SECTION_TYPES} from "../../../configs/section";
    import {STYLE_INJECTION_MIXIN} from "../../../mixins/style-injection-mixin";
    import {EVENT_CONSTANTS} from "../../../configs/events";
    import SectionCopyModal from "../modal-config-views/SectionCopyModal";

    // GlobalModal runner id for "Copy a section from another form" (ControlView uses control ids,
    // so this can never be mistaken for a control's move modal).
    const SECTION_COPY_RUNNER_ID = 'section-copy'

    export default {
        name: "AddSectionControl",
        mixins: [STYLE_INJECTION_MIXIN],
        props: {
            // the site whose forms the copy modal lists (FormBuilder's siteID)
            siteID: {
                type: String,
                default: ''
            },
            // the form being edited (formConfig.formIDForWeb), left out of the copy modal's list
            excludeFormId: {
                type: String,
                default: ''
            }
        },
        data: () => ({
            show: false,
            sectionTypes: SECTION_TYPES
        }),
        methods:{
            showOption() {
                this.show = !this.show;
            },
            addNew(type) {
                this.$emit('addSectionNotify', type)
            },

            /**
             * "Copy a section from another form…" -> open the GlobalModal; onModalOpened injects the picker.
             */
            openCopyModal() {
                this.$formEvent.$emit(EVENT_CONSTANTS.BUILDER.MODAL.OPEN, SECTION_COPY_RUNNER_ID)
            },

            /**
             * [Emit-from-GlobalModal] Inject SectionCopyModal into OUR modal only. GlobalModal.updateBody
             * reads just { runnerId, component, data }, so this is a plain object (as ControlView does).
             */
            onModalOpened(runnerId) {
                if (runnerId !== SECTION_COPY_RUNNER_ID) {
                    return
                }
                this.$formEvent.$emit(
                    EVENT_CONSTANTS.BUILDER.MODAL.INJECT,
                    {
                        runnerId: SECTION_COPY_RUNNER_ID,
                        component: SectionCopyModal,
                        data: { siteID: this.siteID, excludeFormId: this.excludeFormId }
                    },
                    "Copy a section from another form"
                )
            },

            /**
             * [Emit-from-GlobalModal] A section was picked -> FormBuilder grafts it
             * (form-builder-event-handler.js sectionCopyFromForm). Nothing is saved until Save.
             */
            onModalSaveAndClose(runnerId, data) {
                if (runnerId !== SECTION_COPY_RUNNER_ID || !data || !data.sourceConfig || !data.sectionId) {
                    return
                }
                this.$formEvent.$emit(
                    EVENT_CONSTANTS.BUILDER.SECTION.COPY_FROM_FORM,
                    data.sourceConfig,
                    data.sectionId
                )
            }
        },

        created() {
            this.$formEvent.$on(EVENT_CONSTANTS.BUILDER.MODAL.OPENED, this.onModalOpened)
            this.$formEvent.$on(EVENT_CONSTANTS.BUILDER.MODAL.SAVE_AND_CLOSE, this.onModalSaveAndClose)
        },

        beforeDestroy() {
            // $formEvent is app-global: without this, every builder ever opened would keep
            // relaying the copy, and one pick would graft the section once per stale instance.
            this.$formEvent.$off(EVENT_CONSTANTS.BUILDER.MODAL.OPENED, this.onModalOpened)
            this.$formEvent.$off(EVENT_CONSTANTS.BUILDER.MODAL.SAVE_AND_CLOSE, this.onModalSaveAndClose)
        }
    }
</script>
